<template>
  <div class="my-pooq-view-wrapper" data-scroll-element="true">
    <div class="sticky-area" v-if="device === 'mobile'">
      <common-header title="진행중인 이벤트" :is-back-btn="true" :back-fn="close" :is-close-btn="true" :close-fn="close"></common-header>
    </div>
    <div class="event-view-wrap" v-if="!isLoading" data-scroll-element="true">
      <div class="event-view-tit">
        <strong class="event-tit">{{ eventTitle }}</strong>
        <p class="event-text">{{ startDate }} ~ {{ endDate }}</p>
      </div>
      <div class="event-view-img">
        <img :src="getImage(eventPosterImage)" :alt="setAlt()"/>
      </div>

      <EventContentList
        v-if="hasEventContentList"
        :event-content-list="eventContentsList"
        :content-type="contentType"
        @load-more="loadMore()"
      />
    </div>
  </div>
</template>

<script>
import { EventService } from '@/common/api/api.service'
import _ from 'lodash'
import { infiniteScroll } from '@/common/directives'
import utils from '@/common/util/utils'
import CommonHeader from '@/components/header/template/commonHeader'
import { resizeThumbnail } from '@/common/image.filter'
import EventContentList from '@/components/lnb/event/EventContentList'

export default {
  name: 'EventDetailView',
  components: { EventContentList, CommonHeader },
  directives: {
    infiniteScroll
  },
  data () {
    return {
      eventId: '',
      eventDetailData: {},
      eventContentsList: [],
      offset: 0,
      limit: 20,
      endOfList: true,
      device: utils.cookies.getDevice(),
      isLoading: true,
      idDataLoading: false
    }
  },
  computed: {
    isLoaded () {
      return Object.keys(this.eventDetailData).length > 0 && this.hasEventContentList
    },
    eventTitle () {
      return _.get(this.eventDetailData, 'eventtitle', '이벤트')
    },
    eventPosterImage () {
      return _.get(this.eventDetailData, 'detailimage', '')
    },
    startDate () {
      return _.get(this.eventDetailData, 'startdate', '')
    },
    endDate () {
      return _.get(this.eventDetailData, 'enddate', '')
    },
    contentType () {
      return _.get(this.eventDetailData, 'contenttype', '')
    },
    hasEventContentList () {
      return this.eventContentsList.length > 0
    }
  },
  methods: {
    getImage (img) {
      return resizeThumbnail(img, { width: 0, height: 0, option: '20', quality: 80 })
    },
    setAlt () {
      const { eventtitle = '', description = '', startdate = '', enddate = '', gift = '', announcementdate = '' } = this.eventDetailData
      const defaultAlt = eventtitle && description && startdate && enddate && gift && announcementdate
        ? `${eventtitle} ${description} 기간은 ${startdate}부터 ${enddate}까지 입니다.`
        : ''
      const giftAlt = gift === '' ? '' : ` 이벤트 경품은 ${gift}입니다. 당첨자 발표일은 ${announcementdate}입니다.`
      return defaultAlt + giftAlt
    },
    loadMore () {
      if (this.endOfList) {
        this.isLoading = false
        return
      }
      if (this.idDataLoading) return
      this.setEventContentList()
    },
    setData () {
      this.isLoading = true

      EventService.getEventDetail({ eventid: this.eventId }).then(({ data }) => {
        this.eventDetailData = data
        this.endOfList = false
        this.setEventContentList()
      })
    },
    setEventContentList () {
      this.idDataLoading = true
      EventService.getEventDetailContent(
        {
          eventid: this.eventId,
          offset: this.offset,
          limit: this.limit,
          contentType: this.contentType
        }).then(({ data }) => {
        this.offset += this.limit

        const [ eventData ] = data
        const { list = [] } = eventData

        this.eventContentsList = [...this.eventContentsList, ...list]
        this.endOfList = list.length === 0
        this.isLoading = false
        this.idDataLoading = false
      })
    },
    close () {
      this.$router.back()
    }
  },
  created () {
    this.eventId = this.$route.params.eventid
    this.setData()
  }
}
</script>

<style scoped>
  .event-view-wrap {
    position: relative;
    width: 100%;
    height: 100vh;
    padding: 0 10px 10px 10px;
  }
  .displayNone + .my-wrap .my-pooq-view-wrapper .event-view-wrap{
    height: auto;
  }
  .event-view-wrap::-webkit-scrollbar{
    display: none
  }
  .event-view-img img {
    width: 100%;
  }
  .event-view-tit {
    padding: 17px 0;
  }
  .event-view-tit .event-tit {
    padding: 0 0 5px;
  }
  .event-tit, .event-tit02 {
    display: block;
    color: #fff;
  }
  .event-tit {
    padding: 15px 10px 10px;
    font-size: 16px;
  }
  .event-view-tit .event-text {
    padding: 0;
  }
  .event-text {
    font-size: 12px;
    color: #a5a5a5;
    padding: 0 10px 3px;
  }
  .event-con-wrap {
    position:relative;
    width: 100%;
    height: 100%;
    display: block;
  }
</style>
